import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useLogout } from '@/features/auth';
import { useToast } from '@/legacy/hooks/useToast';
import { useDisclosure } from '@/shared/hooks/useDisclosure';

export const useTopBarLogout = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { showToast } = useToast();
	const { mutateAsync: logout } = useLogout();

	const {
		open: isLogoutModalOpen,
		onOpen: openLogoutModal,
		onClose: closeLogoutModal,
	} = useDisclosure();

	const handleLogout = useCallback(async () => {
		try {
			await logout();
			navigate('/');
		} catch {
			showToast(t('errors.unexpected_error'), 'error');
		}
	}, [logout, navigate, showToast, t]);

	return {
		isLogoutModalOpen,
		openLogoutModal,
		closeLogoutModal,
		handleLogout,
	};
};
